export function initAppointments(): void {
	const bookBtn = document.getElementById('ac-book-appointment-btn');
	const picker = document.getElementById('ac-pick-program');
	const backBtn = document.getElementById('ac-picker-back-btn');
	const header = document.getElementById('ac-appointments-header');
	const content = document.getElementById('ac-appointments-content');

	if (!bookBtn || !picker || !header || !content) return;

	const showPicker = () => {
		header.style.display = 'none';
		content.style.display = 'none';
		picker.style.display = 'block';
	};

	const showList = () => {
		picker.style.display = 'none';
		header.style.display = '';
		content.style.display = '';
	};

	bookBtn.addEventListener('click', showPicker);
	document.getElementById('ac-book-appointment-btn-empty')?.addEventListener('click', showPicker);
	backBtn?.addEventListener('click', showList);
}
